import { api } from '../lib/apiClient';

/**
 * The Scripts monitor: running bulk campaigns across every user (backend/routes/scriptMonitor.js).
 *
 * `campaignRef` is the internal campaign id. It is passed back to the server to target
 * exactly one campaign and is never shown in the UI.
 */

/**
 * @returns {Promise<{success: boolean, viewer: {isOperator: boolean}, campaigns: Array<{
 *   campaignRef: string, ownerName: string, ownerEmail: string|null, dataFile: string,
 *   status: 'running'|'stopping'|'stopped'|'completed'|'failed'|'paused',
 *   canKill: boolean, startedAt: string|null, updatedAt: string|null, stoppedBy: string|null}>}>}
 */
export function listRunningCampaigns(signal) {
  return api.get('/api/scripts/campaigns', { signal });
}

/**
 * One campaign's header data plus log lines after `after` (an index into the
 * append-only log). Omit `after` for the most recent tail.
 */
export function getCampaignLogs(campaignRef, after, signal) {
  return api.get(`/api/scripts/campaigns/${encodeURIComponent(campaignRef)}/logs`, {
    query: { after },
    signal
  });
}

/**
 * Stops that one campaign — the same stop as its owner's Stop Sending button. The
 * server authorizes it (owner, or a CAMPAIGN_OPERATORS user) and answers with the
 * confirmed status: 'stopping' while in-flight sends finish, then 'stopped'.
 */
export function killCampaign(campaignRef) {
  return api.post(`/api/scripts/campaigns/${encodeURIComponent(campaignRef)}/kill`, {});
}
